export default __webpack_public_path__ + "static/media/times_attempted.0c654b80.csv";